import script from "./RecordGeometry.vue?vue&type=script&setup=true&lang=ts"
export * from "./RecordGeometry.vue?vue&type=script&setup=true&lang=ts"

import "./RecordGeometry.vue?vue&type=style&index=0&id=3512fda8&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3512fda8"]])

export default __exports__